import React, { useContext, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { BetaContext } from '../context/BetaContext';
import './BetaAuth.css';

const BetaRegisterPage = () => {
  const navigate = useNavigate();
  const { register } = useContext(BetaContext);
  const [inviteCode, setInviteCode] = useState('');
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      await register({ inviteCode, firstName, lastName, email, password });
      navigate('/user-dashboard');
    } catch (err) {
      setError('Unable to register with that invite code.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="beta-auth">
      <div className="beta-auth__card">
        <h2>RS Education Beta Registration</h2>
        {error && <div className="beta-auth__error">{error}</div>}
        <form onSubmit={handleSubmit}>
          <label>
            Invite Code
            <input value={inviteCode} onChange={(e) => setInviteCode(e.target.value)} required />
          </label>
          <label>
            First Name
            <input value={firstName} onChange={(e) => setFirstName(e.target.value)} required />
          </label>
          <label>
            Last Name
            <input value={lastName} onChange={(e) => setLastName(e.target.value)} required />
          </label>
          <label>
            Email
            <input type="email" value={email} onChange={(e) => setEmail(e.target.value)} required />
          </label>
          <label>
            Password
            <input type="password" value={password} onChange={(e) => setPassword(e.target.value)} required />
          </label>
          <button type="submit" disabled={loading}>
            {loading ? 'Creating...' : 'Create Account'}
          </button>
        </form>
        <p>
          Already have access? <Link to="/beta/login">Sign in</Link>
        </p>
      </div>
    </div>
  );
};

export default BetaRegisterPage;
